import { render, staticRenderFns } from "./TopicMembersItem.vue?vue&type=template&id=3f88e684&"
import script from "./TopicMembersItem.vue?vue&type=script&lang=js&"
export * from "./TopicMembersItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports